// extracted by mini-css-extract-plugin
export default {"ReplaceVideoDropzone":"_ReplaceVideoDropzone--ATgEv","Disabled":"_Disabled--Ta7Nf"};